import { mapFromHit } from '~/composables/Mapper/Article';
import type { SponsoredArticleHit } from "~~/models/AisSearch/Result";
import type { AdditionalArticle, BundleArticle, FullArticleDocument } from '@expert/types';
import { buildArticleLinkFromAdditionalArticle, buildArticleLinkFromHit } from "~/composables/ExpApi/expArticle";
import { mapToExpPrice } from "~/composables/ExpApi/expSearch";

export const mapArticleSlideFromSponsoredArticleHit = (sponsoredArticleHit: SponsoredArticleHit): ArticleSlide => {
    const articleSlide = mapArticleSlideFromHit(sponsoredArticleHit);
    articleSlide.beacons = sponsoredArticleHit.beacons;
    return articleSlide;
}

export const mapArticleSlideFromHit = (hit: Partial<FullArticleDocument>): ArticleSlide => {
    return {
        id: hit?.objectID,
        type: 'article',
        name: hit?.articleView?.contextSensitiveData?.title,
        link: buildArticleLinkFromHit(hit),
        image: hit?.articleView?.contextSensitiveData?.primaryImage,
        isWarranty: false,
        brand: hit?.brand?.name,
        expArticle: mapFromHit(hit),
        expPrice: mapToExpPrice(hit?.storeData, useCurrentStore()?.value?.id),
    };
}

export const mapArticleSlideFromAdditionalArticle = (article: AdditionalArticle): ArticleSlide => {
    return {
        type: 'article',
        ...article,
        link: buildArticleLinkFromAdditionalArticle(article),
        isWarranty: false,
    };
}

export const mapArticleSlideFromBundleArticle = (article: BundleArticle): ArticleSlide => {
    return {
        type: 'article',
        id: article.id,
        link: article.link,
        name: article.name,
        image: article.image,
        isWarranty: article.isWarranty,
        brand: typeof article?.brand === 'string' ? article?.brand : article?.brand.name,
        expPrice: article?.expPrice,
        expArticle: {
            articleId: article?.id,
            brandId: typeof article?.brand === 'object' ? article?.brand.id : undefined,
            technicalData: article?.articleClassification?.values?.['@arrayMap'],
        },
    };
}
